// @ts-nocheck
import { capitalize } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { ButtonUI, MultipleTagSelector } from 'sonata-react-components';

import { reportingSetSectionsVisibility } from '@/store/actions/reporting.actions';
import { ReportingSectionTogglesStyle } from './reportingSectionToggles.style';

type Props = {
  onSaved: () => void;
  onSectionsChanged: (newStatuses: Record<string, boolean>) => void;
  saved: boolean;
  sections: {
    descriptionId: string;
    id: string;
    selected: boolean;
  }[];
};

function SectionToggles({ onSaved, onSectionsChanged, saved, sections }: Props) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const toggleSections = useCallback(
    activateSections => {
      const sectionsStatuses = sections.reduce(
        (acc, { id }) => ({
          ...acc,
          [id]: activateSections.includes(id)
        }),
        {}
      );
      onSectionsChanged(sectionsStatuses);
    },
    [sections]
  );

  const items = useMemo(() => {
    return sections.map(({ descriptionId, id }) => ({
      label: formatMessage({
        defaultMessage: capitalize(id),
        id: descriptionId
      }),
      value: id
    }));
  }, [sections]);

  const defaultSelectedItems = useMemo(() => {
    return sections.filter(({ selected }) => selected).map(({ id }) => id);
  }, [sections]);

  const saveTogglesSettings = useCallback(() => {
    dispatch(
      reportingSetSectionsVisibility(
        sections.reduce(
          (acc, { id, selected }) => ({
            ...acc,
            [id]: selected
          }),
          {}
        )
      )
    );
    onSaved();
  }, [sections]);

  return (
    <ReportingSectionTogglesStyle className="reportingSectionToggles">
      <div className="reportingSectionToggles__container reportingHeader__wrapper">
        <MultipleTagSelector
          allItem
          className="reportingSectionToggles__sectionsSelector"
          defaultSelectedItems={defaultSelectedItems}
          id="reporting-sections-toggles-selector"
          items={items}
          onChange={toggleSections}
        />
        <ButtonUI
          className="reportingSectionToggles__saveButton"
          disabled={saved}
          icon="fal fa-save"
          id="reporting-sections-toggles-save-button"
          onClick={saveTogglesSettings}
          size="ultraSmall"
          type="primary"
        />
      </div>
    </ReportingSectionTogglesStyle>
  );
}

export default SectionToggles;
